<template>
  <div v-if="collections && collections.length" class="collection-images">
    <h4 class="font-size-12" :class="{ mobile: isMobile }">{{ parentCategoryLabel }} Collection</h4>

    <collection-carousel v-if="isMobile" :collections="collections" :parent-category-label="parentCategoryLabel" />

    <div v-else class="collection-list">
      <div v-for="(item, index) in collections" v-if="item.info.layout === 'IMAGE'" class="image-container">
        <collection-image-list-item :parent-category-label="parentCategoryLabel" :collection="item" :index="index" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.collection-images {
  position: relative;
  h4 {
    margin-bottom: 16px;

    &.mobile {
      margin-top: 24px;
    }
  }

  .collection-list {
    display: flex;
    margin-bottom: 40px;

    :not(:last-child) {
      margin-right: 24px;
    }
  }

  .mobile-collection-item {
    padding-right: 16px;
  }
}
</style>

<script>
import InlineSvg from "vue-inline-svg";
import CollectionImageListItem from "./collectionImageListItem";
import CollectionCarousel from "./collectionCarousel";

export default {
  components: {
    CollectionCarousel,
    CollectionImageListItem,
    InlineSvg,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  props: {
    collections: {
      type: Array,
      default: [],
    },
    parentCategoryLabel: {
      type: String,
      default: "",
    },
  },
  beforeMount() {
    this.setMobileState();
    window.addEventListener("resize", this.setMobileState);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setMobileState);
  },

  methods: {
    setMobileState,
  },
};

function setMobileState() {
  this.isMobile = window.innerWidth < 770;
}
</script>
